import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { AlertIcon } from 'src/icons';
import { deleteSpecialtyAction } from 'src/modules/SuperAdmin/store/actions/specialty.action';
import { SuperAdminModal } from '../../../baseComponents';

const DeleteSpecialty = ({
  isOpen,
  setIsOpen,
  isfilterOn,
  selectedSpecialty,
}) => {
  const dispatch = useDispatch();
  const { getSpecialtyById } = useSelector((state) => state?.specialtyState);

  const initialValues = {
    condition_id: '',
  };

  const sections = [
    {
      heading: (
        <div className="flex items-center mb-4">
          <AlertIcon className="mr-2" />
          {getSpecialtyById?.allow_delete
            ? 'Remove specialty'
            : `Cannot delete specialty ${getSpecialtyById?.specialty_name}`}
        </div>
      ),
      className: 'grid grid-cols-1 gap-4',
      fields: [
        {
          type: 'label',
          title: (
            <>
              <span>
                {getSpecialtyById?.allow_delete ? (
                  'Are you sure you want to remove this specialty'
                ) : (
                  <span>
                    <span>You cannot delete specialty</span>
                    <span className="font-bold ml-1">
                      {getSpecialtyById?.specialty_name}
                    </span>
                    <span className="ml-1">
                      since it is linked to other data
                    </span>
                  </span>
                )}{' '}
              </span>
              <span className="font-bold">
                {' '}
                {getSpecialtyById?.allow_delete
                  ? `${getSpecialtyById?.specialty_name} ?`
                  : ''}{' '}
              </span>
            </>
          ),
        },
      ],
    },
  ];

  return (
    <SuperAdminModal
      open={isOpen}
      sections={sections}
      closable={false}
      initialValues={initialValues}
      submitButtonText={getSpecialtyById?.allow_delete ? 'Submit' : null}
      cancelButtonText={getSpecialtyById?.allow_delete ? 'Cancel' : 'Go back'}
      className={'delete-modal'}
      handleCancel={() => {
        setIsOpen(false);
      }}
      handleSubmit={() => {
        dispatch(
          deleteSpecialtyAction(
            getSpecialtyById?.specialty_id,
            setIsOpen,
            isfilterOn,
            selectedSpecialty
          )
        );
      }}
    />
  );
};

export default DeleteSpecialty;
